import { render, staticRenderFns } from "./PFormInputTextSearch.vue?vue&type=template&id=33a7404f&scoped=true&"
import script from "./PFormInputTextSearch.vue?vue&type=script&lang=ts&"
export * from "./PFormInputTextSearch.vue?vue&type=script&lang=ts&"
import style0 from "./PFormInputTextSearch.vue?vue&type=style&index=0&id=33a7404f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a7404f",
  null
  
)

export default component.exports